import React, { useState, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { color } from 'theme';
import { useTeamColors } from 'hooks';

const TooltipWrapper = styled.div`
  position: relative;
`;

const TooltipText = styled.p`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 150px;
  z-index: 999;
  padding: 6px 10px;
  border: 1px solid ${(props) => props.$borderColor || color.red};
  border-radius: 4px;
  background: ${color.backgroundDark};
  color: #fff;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
  opacity: ${(props) => (props.$isOpen ? '1' : '0')};
  visibility: ${(props) => (props.$isOpen ? 'visible' : 'hidden')};
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;
  pointer-events: none;

  /* Tooltip arrow */
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${(props) => props.$borderColor || color.red};
  }
`;

export const Tooltip = ({ text, children, isActive = true }) => {
  const tooltipRef = useRef();
  const [showTooltip, setShowTooltip] = useState(false);
  const { mainColor } = useTeamColors();

  // Detect if device supports touch (mobile/tablet)
  const isTouchDevice =
    'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const mouseHoverHandler = useCallback(() => {
    // Don't show tooltips on touch devices
    if (isActive && !isTouchDevice) {
      setShowTooltip((prevState) => !prevState);
    }
  }, [isActive, isTouchDevice]);

  return (
    <>
      <TooltipWrapper
        onMouseEnter={mouseHoverHandler}
        onMouseLeave={mouseHoverHandler}
        ref={tooltipRef}
      >
        {children}
      </TooltipWrapper>
      {tooltipRef.current && !isTouchDevice
        ? ReactDOM.createPortal(
            <TooltipText $borderColor={mainColor} $isOpen={showTooltip}>
              {text}
            </TooltipText>,
            tooltipRef.current
          )
        : null}
    </>
  );
};
